const accountFileTypes = {
    ContractsAndHandbooks: 0,
    HealthAndSafety: 1,
    
};

export default accountFileTypes;